import { useMemo } from "react";
import { Card as CardDisplay } from "stentor-models";
import { ChatCard } from "../components/ChatCard";
import { ChatMessagePart } from "../components/ChatMessagePart";
import { useButtonCallback } from "../hooks";
import { isCard } from "../utils/guards";
import { convertFromCardDisplay } from "../utils/responseToMessage";
import { ChatServerCard } from "../xapp/ChatServerMessage";
import { MessageMiddlewareBuilder, MessageMiddlewareFC } from "./message-middleware";

export const CardMiddlewareWidget: MessageMiddlewareFC<CardDisplay> = (props) => {
    const { msg, ctx } = props;

    const card = useMemo<ChatServerCard>(() => convertFromCardDisplay(msg), [msg]);

    const user = ctx.user;

    const handleButton = useButtonCallback();

    return (
        <ChatMessagePart showAvatar={true} user={user}>
            <div className="chat-msg">
                <ChatCard card={card} onButtonClick={handleButton} />
            </div>
        </ChatMessagePart>
    );
};

export const CardMiddleware: MessageMiddlewareBuilder = (next) => (props) => {
    const { msg, ctx } = props;

    if (isCard(msg)) {
        return <CardMiddlewareWidget msg={msg} ctx={ctx} />;
    }

    return next(props);
};
